import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useViewObserver } from '../../utils/useViewObserver';
import { login } from '../../../services/schibstedAccount';
import { useEngagementTracking } from '../../utils/useEngagementTracking';
import { ActionButton } from '../ActionButton/ActionButton';

import type { FC } from 'react';

export const LoginButton: FC = () => {
  const ref = useRef<HTMLButtonElement>(null!);
  const { t } = useTranslation();
  const { trackClick, trackView } = useEngagementTracking(
    'header-login-button'
  );

  useViewObserver({
    onView: trackView,
    elementRef: ref,
  });

  const handleClick = () => {
    trackClick('Open');

    login({ source: 'header' });
  };

  return (
    <ActionButton buttonRef={ref} onClick={handleClick}>
      {t('Log in')}
    </ActionButton>
  );
};
